import actionTypes from '../actionTypes';
import { fetch } from '../../api';

function fetchFeedSuccess(initialFeed, action) {
  const { feed = {}, ...other } = action;
  return Object.assign(
    other,
    {
      type: actionTypes.FEED_REQUEST_SUCCESS,
      feed: { ...initialFeed, receptionDate: Date.now(), ...feed  },
      isAsynchronous: true,
    },
  );
}

export function invalidateFeed(id) {
  return {
    type: actionTypes.FEED_INVALIDATE,
    feed: { id },
    bypassMiddleware: true,
  };
}

export function resetFeed(id) {
  return {
    type: actionTypes.FEED_RESET,
    feed: { id },
    bypassMiddleware: true,
  };
}

export function fetchFeed(feed, didInvalidate, fetchData) {
  return async function (dispatch, getState) {
    dispatch({
      type: actionTypes.FEED_REQUEST,
      feed: { ...feed, didInvalidate },
      bypassMiddleware: true,
    });

    try {
      const action = await fetchData(getState);
      return dispatch(fetchFeedSuccess(feed, action));
    } catch (error) {
      return dispatch({ type: actionTypes.FEED_REQUEST_FAILURE, feed, error, isAsynchronous: true });
    }
  };
}

export function fetchNewsFeed(feed, queries = {}, from) {
  const fetchData = async function fetchData() {
    const { payload } = await fetch('newsfeed', { query: { ...queries, from } });
    const { groups, users, hits } = payload;
    const posts = hits.hits.map(u => u._source);
    return { data: { groups, users, posts } };
  };

  return fetchFeed(feed, from === 0, fetchData);
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/general.js